<template>
  <div>
    <button @click="show = true" class="btn btn-outline-gray btn-sm is-border-1">
      <i class="icon12-import-primary icon-left"></i>{{ $t('import') }}
    </button>
    <b-modal v-model="show" title="Tải lên danh sách bệnh nhân" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus>
      <div class="form-group">
        <label><b>Bước 1: {{ $t('downloadTemplate') }}</b></label>
        <div>
          <button @click="downloadTemplate" class="btn btn-sm btn-secondary mr-1 mb-2">
            <i class="fa fa-fw fa-lg fa-file-excel-o"></i> Tập_tin_Excel_mẫu.xlsx
          </button>
        </div>
      </div>
      <div class="form-group">
        <label><b>Bước 2: Điền thông tin vào file mẫu</b></label>
        <p>Lưu ý: Dòng đầu tiên của tập tin cần để nguyên vẹn để xác định các trường thông tin, không cần tuân thủ đúng
          thứ tự</p>
      </div>
      <div class="form-group">
        <label><b>Bước 3: Tải lên file đã điền thông tin</b></label>
        <b-form-file class="mb-3"
                     v-model="file"
                     :placeholder="$t('fileInputPlaceholder')"
                     :drop-placeholder="$t('fileInputPlaceholder')"
                     :browse-text="$t('selectFile')"
                     :disabled="reading||totalRows>0"
                     accept="application/x-iwork-keynote-sffnumbers,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ></b-form-file>
      </div>
      <div v-if="reading" class="alert alert-warning">
        <b-spinner small variant="primary"></b-spinner>&nbsp;
        <span>{{ $t('importReadingNotice') }}</span>
      </div>
      <div v-if="importing" class="alert alert-warning">
        <b-spinner small variant="primary"></b-spinner>&nbsp;
        <span>{{ $t('importingNotice') }}</span>
      </div>
      <div class="mb-3" v-if="totalRows">
        <b-progress :max="totalRows">
          <b-progress-bar :value="successCount+errorCount"
                          :label="`${(((successCount + errorCount) / totalRows) * 100).toFixed(0)}%`"></b-progress-bar>
        </b-progress>
        <div class="text-center">{{ successCount + errorCount }}/{{ totalRows }} | {{ $t('errors') }}: {{ errorCount }}
          <a @click="downloadErrors" class="btn-link text-primary" href="javascript:;">[{{ $t('detail') }}]</a>
        </div>
      </div>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary" @click="cancel" v-if="!reading&&importing">{{ $t('cancel') }}</button>
        <button class="btn btn-primary" @click="reset" v-if="!reading&&!importing&&totalRows>0">Reset</button>
        <button v-if="totalRows===0" class="btn btn-primary" @click="process" :disabled="reading||importing">
          <b-spinner small v-if="reading||importing"></b-spinner>
          {{ $t('import') }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import fileReaderStream from 'filereader-stream';
import {saveAs} from 'file-saver'
import Excel from 'exceljs';
// import moment from 'moment';

export default {
  props: ['reasonOptions'],
  components: {},
  data() {
    return {
      show: false,
      file: null,
      reading: false,
      importing: false,
      totalRows: 0,
      successCount: 0,
      errorCount: 0,
      importErrors: [],
      cancelRequest: false,
    }
  },
  methods: {
    close(evt) {
      if (this.reading || this.importing) {
        evt.preventDefault();
      } else {
        this.reset();
      }
      this.$bus.$emit('reloadBenhNhanList');
    },
    reset() {
      this.totalRows = 0;
      this.successCount = 0;
      this.errorCount = 0;
      this.importErrors = [];
      this.cancelRequest = false;
      this.reading = false;
      this.importing = false;
      this.file = null;
    },
    process(evt) {
      evt.preventDefault();
      if (!this.file) {
        this.$swal({
          title: this.$t('error'),
          text: this.$t('importFileRequired'),
          icon: 'error',
        });
        return;
      }
      if (this.file.name.endsWith('.xls') || this.file.name.endsWith('.xlsx')) {
        this.reading = true;
        let readStream = fileReaderStream(this.file);
        const workbook = new Excel.Workbook();

        workbook.xlsx.read(readStream).then(async () => {
          if (workbook.worksheets.length === 0) {
            throw new Error(this.$t('invalidFileTemplate'));
          }
          let sheet = workbook.worksheets[0];
          if (sheet.actualRowCount < 3) {
            throw new Error(this.$t('fileHasNoData'));
          }
          let headerRow = sheet.getRow(1);
          let i = 3;
          this.totalRows = sheet.actualRowCount - 2;
          this.reading = false;
          this.importing = true;
          while (i <= sheet.actualRowCount) {
            if (this.cancelRequest) {
              break;
            }
            try {
              let item = await this.getItem(headerRow, sheet.getRow(i));
              await this.$bgService.post('/benh-nhan', item);
              this.successCount++;
            } catch (err) {
              this.importErrors.push({row: i, err: err});
              this.errorCount++;
            }
            i++;
          }
        }).catch(err => {
          this.$swal({
            title: this.$t('error'),
            text: err.message,
            icon: 'error',
          });
        }).finally(() => {
          this.reading = false;
          this.importing = false;
          this.cancelRequest = false;
          this.$bus.$emit('reloadBenhNhanList');
        });
      } else {
        this.$swal({
          title: this.$t('error'),
          text: this.$t('invalidFileType'),
          icon: 'error',
        });
      }
    },
    cancel() {
      this.cancelRequest = true;
    },
    downloadErrors() {
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('Import errors');
      sheet.columns = [
        {header: this.$t('rowNumber'), key: 'row', width: 15},
        {header: this.$t('errors'), key: 'error', width: 50},
      ];
      for (let err of this.importErrors) {
        sheet.addRow({
          row: err.row,
          error: (err.err.response && err.err.response.status === 422) ? err.err.response.data.map(i => `${i.param}: ${i.msg}`).join(', ') : err.err.message
        });
      }
      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        saveAs(
            new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'benh-nhan-import-error.xlsx'
        )
      });
    },
    downloadTemplate: function () {
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('Bệnh nhân');
      let reason = workbook.addWorksheet('Lý do xét nghiệm');
      reason.columns = [{header: 'reason', key: 'reason', width: 150}];
      for (let option of this.reasonOptions) {
        if (!option.value) {
          continue
        }
        reason.addRow({reason: option.text});
      }

      this.setupSheet(sheet);
      let row = {
        testCode: 'Mã XN',
        name: 'Họ tên',
        testReason: 'Lý do XN',
        testDate: 'Ngày lấy mẫu',
        getOutOfHospitalDate: 'Ngày ra khỏi BV / Khu cách ly',
        ctValue: 'Ct-Value',
        ctLevel: 'Mức CT',
        phone: 'Số điện thoại',
        dob: 'Năm sinh',
        age: 'Tuổi',
        gender: 'Giới tính',
        address: 'Số nhà',
        wardCode: 'Phường/Xã',
        districtCode: 'Quận/Huyện',
        provinceCode: 'Tỉnh thành',
        note: 'Ghi chú',
        fieldDoctor: 'Họ Tên bác sỹ phụ trách/người phụ trách',
        fieldDoctorPhone: 'Điện thoại bác sỹ phụ trách/người phụ trách',
      };
      sheet.addRow(row);
      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        saveAs(
            new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'Tập_tin_Excel_mẫu_bệnh_nhân.xlsx'
        )
      });
    },
    setupSheet(sheet) {
      let cols = [
        {header: 'testCode', key: 'testCode', width: 15},
        {header: 'name', key: 'name', width: 15},
        {header: 'testReason', key: 'testReason', width: 15},
        {header: 'testDate', key: 'testDate', width: 15},
        {header: 'getOutOfHospitalDate', key: 'getOutOfHospitalDate', width: 15},
        {header: 'ctValue', key: 'ctValue', width: 15},
        {header: 'ctLevel', key: 'ctLevel', width: 15},
        {header: 'phone', key: 'phone', width: 15},
        {header: 'dob', key: 'dob', width: 15},
        {header: 'age', key: 'age', witdh: 15},
        {header: 'gender', key: 'gender', width: 15},
        {header: 'address', key: 'address', width: 15},
        {header: 'wardCode', key: 'wardCode', width: 15},
        {header: 'districtCode', key: 'districtCode', width: 15},
        {header: 'provinceCode', key: 'provinceCode', width: 15},
        {header: 'note', key: 'note', width: 15},
        {header: 'fieldDoctor', key: 'fieldDoctor', width: 15},
        {header: 'fieldDoctorPhone', key: 'fieldDoctorPhone', width: 15},
      ];
      sheet.columns = cols;
    },
    async getItem(headerRow, row) {
      let item = {};
      for (let j = 1; j <= headerRow.cellCount; j++) {
        let key = headerRow.getCell(j).value;
        let value;
        if (row.getCell(j).isHyperlink) {
          value = row.getCell(j).value.text;
        } else {
          value = row.getCell(j).value;
        }
        if (row.getCell(j).result) {
          value = row.getCell(j).result
        }
        if (typeof(value) === 'object') {
          value = ''
        }
        if (key === 'gender') {
          if (value && (value === 'Nam' || value === 'nam' || value === 'NAM' || value === 1 || value === '1')) {
            item[key] = 'male'
          } else {
            item[key] = 'female'
          }
        } else {
          item[key] = value;
        }
      }
      return item;
    }
  }
}
</script>
